import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (accepted === 'true') {
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }
  }, [location]);
}
